/**
 * 和传统的 lodash.get 不一样，考虑了带 id 的对象的数组。比如，这里 `foo/yy/name` 可以获取到字符串 ss：
 *
 * ```yaml
 * {
 *   foo: [
 *     {id: 'xx', name: 'aa'},   # foo/xx
 *     {id: 'yy', name: 'ss'},   # foo/yy
 *   ]
 * }
 * ```
 */
export default function getDSDataAtPath(data, path) {
    const parts = typeof path === 'string' ? path.split('/').filter(Boolean) : path; // 去掉 #
    let ptr = data;
    while (ptr && parts.length) {
        const part = parts.shift();
        if (Array.isArray(ptr) && Number.isNaN(+part))
            ptr = ptr.find((x) => x.id === part);
        else
            ptr = ptr[part];
    }
    return ptr;
}
